import { render } from "./HermesSettings.vue?vue&type=template&id=55bfe52e&scoped=true"
import script from "./HermesSettings.vue?vue&type=script&lang=js"
export * from "./HermesSettings.vue?vue&type=script&lang=js"

import "./HermesSettings.vue?vue&type=style&index=0&id=55bfe52e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bfe52e"]])

export default __exports__